"use client";

import Script from "next/script";
import { useAppContext } from "@components/Provider";
import Sites from "src/constants/Sites";

export default function AdScripts() {
  const { data, siteId, isMobile, isTablet } = useAppContext();

  const adSettings = data?.SiteSettings?.ad_settings;
  if (!adSettings) return null;

  const { show_ads: showAdsOnSite, adnetwork, domain } = adSettings;

  if (adnetwork === "SheKnows" && domain && showAdsOnSite) {
    const headerUrl = `https://ads.blogherads.com/bh/41/412/412983/${domain}/header.js`;
    return (
      <>
        <Script
          src="https://ads.blogherads.com/static/blogherads.js"
          strategy="afterInteractive"
        />
        <Script src={headerUrl} strategy="afterInteractive" />

        {!isMobile && !isTablet && (
          <Script id="desktop-adhesion" strategy="afterInteractive">{`
            var blogherads = blogherads || {};
            blogherads.adq = blogherads.adq || [];
            blogherads.adq.push('frame2');
          `}</Script>
        )}

        {(isMobile || isTablet) && siteId !== Sites.EARLYBIRDBOOKS && (
          <Script id="mobile-adhesion" strategy="afterInteractive">{`
            var blogherads = blogherads || {};
            blogherads.adq = blogherads.adq || [];
            blogherads.adq.push('bottom');
          `}</Script>
        )}
      </>
    );
  }

  if (adnetwork === "SheKnows" && !showAdsOnSite) {
    return (
      <>
        <Script id="disable-shemedia" strategy="afterInteractive">{`
          var blogherads = blogherads || {};
          blogherads.adq = blogherads.adq || [];
          blogherads.adq.push(function() {
            blogherads.disableAds();
          });
        `}</Script>
        <Script id="disable-adhesive-kill" strategy="afterInteractive">{`
          var blogherads = blogherads || {};
          blogherads.adq = blogherads.adq || [];
          blogherads.adq.push(function() {
            blogherads.disableAutoSlot('frame1')
          })
        `}</Script>
      </>
    );
  }

  if (showAdsOnSite) {
    return (
      <Script
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
        data-ad-client="ca-pub-8178679793640375"
        strategy="lazyOnload"
      />
    );
  }

  return null;
}
